import React from 'react';
import 'twin.macro';
import { GoToDateForm } from '../form';
import { MenuHeader, MenuContent } from '.';

export const GoToDateMenu = () => {
  return (
    <>
      <MenuHeader title='Ga naar datum' />
      <MenuContent>
        <GoToDateForm />
      </MenuContent>
    </>
  );
};
